import AbstractModel from './utils/abstractModel'
import CurrentSubscription from './currentSubscription'
import UserProfile from './userProfile'
import types from './utils/types'

class User extends AbstractModel {
  /**
   * @type {integer}
   */
  id

  /**
   * @type {CurrentSubscription, undefined}
   */
  currentSubscription

  /**
   * @type {string}
   */
  guid

  /**
   * @type {UserProfile}
   */
  profile

  constructor(json) {
    super(json)
    this.id = json.id
    this.currentSubscription =
      json.current_subscription &&
      Object.keys(json.current_subscription).length > 0
        ? new CurrentSubscription(json.current_subscription)
        : undefined
    this.guid = json.guid
    this.profile = json.profile && new UserProfile(json.profile)
    this.validate()
  }

  validate() {
    this.assertType('id', [types.NUMBER])
    this.assertType('currentSubscription', [CurrentSubscription, types.NULL])
    this.assertType('guid', [types.STRING])
    this.assertType('profile', [UserProfile])
  }

  /**
   * Indicate whether user has an active subscription
   * @readonly
   * @type {boolean}
   */
  get hasActiveSubscription() {
    return this.currentSubscription?.isExpired === false
  }
}

export default User
